
import request from '@/utils/request'
import common from '@/utils/common'

const _fun = (data) => {
	let _url = ''
	if (data) {
		const _data = Object.keys(data)
		_data.map(i => {
			if(data[i] !== '') _url += `&${i}=${data[i]}`
		})
	}
	return _url
}
const api = {
	//————————————————————————分类管理——————————————————————————————//

	async addCategory(data) {
		const _res = await request.post(`/product/category`, data)
		return _res
	},
	//获取三级类目筛选信息
	async getCategoryOption(id) {
		const _res = await request.get(`/product/category/select?parent_id=${id}`)
		return _res
	},
	//单独获取三级类目信息
	async getTopCategory() {
		const _res = await request.get(`/product/category/select?level=${3}`)
		return _res
	},
	//分类列表
	async categoryList(data) {
		const params = common.formatParams(data)
		const _res = await request.get(`/product/category?${params}`)
		return _res
	},
	//修改列表状态
	async changeStatus(id, is_open) {
		const _res = await request.put(`/product/category`, { id, is_open })
		return _res
	},
	//删除分类
	async delCategory(id) {
		const _res = await request.delete(`/product/category?id=${id}`)
		return _res
	},
	//编辑分类
	async fixCategory(data) {
		const _res = await request.put(`/product/category`, data)
		return _res
	},

	//————————————————————————检测报告——————————————————————————————//

	//新增检测报告
	async addReport(data) {
		const _res = await request.post(`/product/report`, data)
		return _res
	},
	//修改检测报告
	async editReport(data) {
		const _res = await request.put(`/product/report`, data)
		return _res
	},
	// 检测报告列表
	async reportList(data) {
		const params = common.formatParams(data)
		return await request.get(`product/report?${ params }`)
	},
	// 删除检测报告
	async delReport(id) {
		const _res = await request.delete(`/product/report?id=${id}`)
		return _res
	},

	//————————————————————————商品管理——————————————————————————————//
	//添加商品
	async addProduct(data) {
		const _res = await request.post(`/product/product`, data)
		return _res
	},
	//获取安全等级
	async publicConfig() {
		const _res = await request.get(`/product/config`)
		return _res
	},
	//商品列表
	// async productList(product_name = '', page) {
		async productList(data) {
		// const _url = product_name ? `/product/product?product_name=${product_name}&page=${page}` : `/product/product?page=${page}`
		const params = common.formatParams(data)
		const _url = `/product/product?${params}`
		const _res = await request.get(_url)
		return _res
	},
	//商品详情
	async producDetail(product_sku_id) {
		const _res = await request.get(`/product/product/detail?product_sku_id=${product_sku_id}`)
		return _res
	},
	//修改商品
	async editProduct(data) {
		const _res = await request.put(`/product/product`, data)
		return _res
	},
	async editProductBatch(data) {
		const _res = await request.put(`/product/shelves_product/update_batch`, data)
		return _res
	},
	//删除商品
	async delProduct(product_sku_id) {
		const _res = await request.delete(`/product/product?product_sku_id=${product_sku_id}`)
		return _res
	},
	//设置是否自选
	async changeOptional(data) {
		const _res = await request.put(`/product/product/is_optional_products`, data)
		return _res
	},

	//————————————————————————上架管理——————————————————————————————//
	//上架商品
	async upProduct(data) {
		const _res = await request.post(`/product/shelves_product`, data)
		return _res
	},
	//上架商品列表
	async upProductList(page, data) {
		const url = _fun(data)
		const _res = await request.get(`/product/shelves_product?page=${page}` + url)
		return _res
	},
	// 上架商品列表
	async upProductDetail(id) {
		const _res = await request.get(`/product/shelves_product/detail?id=${id}`)
		return _res
	},
	//批量更新配置
	async updateBatchOptional(data) {
		const _res = await request.put(`/product/shelves_product/update_batch_optional`, data)
		return _res
	},
	// 查询商品列表
	async goodsList(data) {
		const url = _fun(data)
		const _res = await request.get(`/product/product/select?${ url }`)
		return _res
	},
	// 编辑上架信息
	async editUpProduct(data) {
		const _res = await request.put(`/product/shelves_product`, data)
		return _res
	},
	// 删除上架信息
	async delUpProduct(id) {
		const _res = await request.delete(`/product/shelves_product?id=${id}`)
		return _res
	},
	// 查看素材
	async lookSource(id) {
		const _res = await request.get(`/product/shelves_product/source_detail?product_shelves_id=${id}`)
		return _res
	},
	// 编辑新增素材
	async changeSource(product_shelves_id, source_data) {
		const _res = await request.post(`/product/shelves_product/source`, { product_shelves_id, source_data })
		return _res
	},
	// 新增banner
	async addBanner(data) {
		return await request.post(`/product/banner`, data)
	},
	// banner列表
	async getBanner(data) {
		return await request.get(`/product/banner`, { params: data })
	},
	// 删除banner
	async delBanner(data) {
		return await request.delete(`/product/banner`,  { params: data })
	},
	// 回填banner
	async detailBanner(data) {
		return await request.get(`/product/banner/detail`,  { params: data })
	},
	// 编辑banner
	async editBanner(data) {
		return await request.put(`/product/banner`, data)
	},
	// 修改上架状态
	async changeUpStatus(data) {
		return await request.put(`/product/shelves_product/switch_status`, data)
	},
	// 修改显示状态
	async changeShowStatus(data) {
		return await request.put(`/product/shelves_product/is_show`, data)
	},


	// 商品规格方案列表
	async productRelated(data) {
		const params = common.formatParams(data)
		return await request.get(`product/product_shelves_related?${ params }`)
	},
	// 商品规格方案列表all
	async productRelatedSelect(data) {
		const params = common.formatParams(data)
		return await request.get(`product/product_shelves_related/select`)
	},
	// 删除方案
	async delProductRelated(data) {
		return await request.delete(`product/product_shelves_related`,  { params: data })
	},
	// 新增方案
	async addProductRelated(data) {
		return await request.post(`product/product_shelves_related`, data)
	},
	// 编辑方案
	async editProductRelated(data) {
		return await request.put(`product/product_shelves_related`, data)
	},
	async chooseProduct(data) {
		const params = common.formatParams(data)
		return await request.get(`product/shelves_product/select?${params}`)
	},
	// 新增拼团商品
	async addCollageGoods(data) {
		return await request.post(`product/order/group`, data)
	},
	// 删除拼团
	async delCollage(data) {
		return await request.delete(`product/order/group`,  { params: data })
	},
	// 修改显示状态
	async editStock(data) {
		return await request.put(`/product/shelves_product/update_stock`, data)
	},
	// 修改商品排序
	async updateSort(data) {
		return await request.put(`/product/shelves_product/update_sort`, data)
	},
	// 到货提醒
	async productArriveNew(data) {
		const params = common.formatParams(data)
		return await request.get(`/product/shelves_product/stock_notice_list?${params}`)
	},
	// 商品专题列表
	async productTopic(data) {
		const params = common.formatParams(data)
		return await request.get(`product/special?${params}`)
	},
	// 更改商品专题状态
	async isOpenProductActive(data) {
		return await request.post(`product/special/is_open`, data)
	},
	// 获取专题管理详情
	async getTopicDetail(data) {
		const params = common.formatParams(data)
		return await request.get(`product/special/detail?${params}`)
	},
	// 添加专题管理
	async addProductTopic(data) {
		return await request.post(`product/special`, data)
	},
	// 编辑专题管理
	async editProductTopic(data) {
		return await request.put(`product/special`, data)
	},
	// 删除专题
	async deleteProductTopic(data) {
		const params = common.formatParams(data)
		return await request.delete(`product/special?${params}`)
	},
	// 商品专题列表(无分页)
	async selectProductTopic(data) {
		const params = common.formatParams(data)
		return await request.get(`product/special/list`)
	},
	// 快捷编辑
	async fastEdit(data) {
		return await request.put(`product/shelves_product/update/quick`, data)
	},
	async saveOptionSetting(data) {
		const _res = await request.put(`/product/shelves_product/update_optional`, data)
		return _res
	},
}
export default api



// WEBPACK FOOTER //
// ./src/api/goods.js